import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { getKey } from '../utils/uid';
import { CHANGE_TOPIC } from '../Datum/types';
import Checkbox from './Checkbox';
import { Provider } from './context';
import { checkinputClass } from './styles';

var CheckboxGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CheckboxGroup, _PureComponent);

  var _super = _createSuper2(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    _this.handleRawChange = _this.handleRawChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(CheckboxGroup.prototype), "componentDidMount", this).call(this);

      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(CheckboxGroup.prototype), "componentWillUnmount", this).call(this);

      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "getContent",
    value: function getContent(d) {
      var renderItem = this.props.renderItem;

      if (typeof renderItem === 'string') {
        return d[renderItem];
      }

      if (typeof renderItem === 'function') {
        return renderItem(d);
      }

      return '';
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      this.forceUpdate();
    }
  }, {
    key: "handleClick",
    value: function handleClick(_val, checked, index) {
      var _this$props = this.props,
          data = _this$props.data,
          datum = _this$props.datum;

      if (checked) {
        datum.add(data[index]);
      } else {
        datum.remove(data[index]);
      }
    }
  }, {
    key: "handleRawChange",
    value: function handleRawChange(value, checked) {
      var datum = this.props.datum;

      if (checked) {
        datum.add(value);
      } else {
        datum.remove(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          block = _this$props2.block,
          data = _this$props2.data,
          datum = _this$props2.datum,
          keygen = _this$props2.keygen,
          children = _this$props2.children,
          style = _this$props2.style;
      var className = classnames(checkinputClass('group', ['no-block', 'block'][Number(block)]), this.props.className);

      if (data === undefined) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className,
            style: style
          },
          /*#__PURE__*/
          React.createElement(Provider, {
            value: {
              onRawChange: this.handleRawChange,
              checked: datum.check.bind(datum)
            }
          }, children))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style
        }, data.map(function (d, i) {
          return (
            /*#__PURE__*/
            React.createElement(Checkbox, {
              checked: datum.check(d),
              disabled: datum.disabled(d),
              key: getKey(d, keygen, i),
              htmlValue: i,
              index: i,
              onChange: _this2.handleClick
            }, _this2.getContent(d))
          );
        }), children)
      );
    }
  }]);

  return CheckboxGroup;
}(PureComponent);

CheckboxGroup.defaultProps = {
  renderItem: function renderItem(d) {
    return d;
  }
};
export default CheckboxGroup;